import * as React from 'react';
import { styled } from '@linaria/react';
import { motion } from 'framer-motion';

interface Props {
  primary?: boolean;
  stretch?: boolean;
  children: React.ReactNode;
}

function PositionAreaItem({
  primary = false,
  stretch = false,
  children,
}: Props) {
  return (
    <Wrapper layout data-primary={primary} data-stretch={stretch}>
      <InnerWrapper
        layout
        data-primary={primary}
        data-stretch={stretch}
      >
        <TextWrapper layout="position">{children}</TextWrapper>
      </InnerWrapper>
      <Reflection layout />
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  position: relative;
  display: flex;
  align-items: stretch;
  font-size: 0.875rem;
  padding: 2px;
  margin: 2px;
  border-radius: 4px;
  background: var(--color-gray-500);

  &[data-primary='true'] {
    background: hsl(50deg 100% 90%);
  }

  &[data-stretch='true'] {
    flex: 1;
    margin: 0;
  }
`;

const InnerWrapper = styled(motion.div)`
  flex: 1;
  padding: 8px 14px;
  border-radius: 2px;
  background: var(--color-gray-100);
  color: var(--color-text);
  white-space: nowrap;

  &[data-primary='true'] {
    background: hsl(50deg 100% 50%);
    color: black;
  }

  &[data-stretch='true'] {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const TextWrapper = styled(motion.span)`
  display: block;
`;

const Reflection = styled(motion.div)`
  position: absolute;
  top: 4px;
  left: 4px;
  right: 4px;
  height: 10px;
  width: calc(100% - 8px);
  background: linear-gradient(to top, transparent, white);
  border-radius: 9px 9px 32px 32px;
  opacity: 0.1;
  pointer-events: none;
`;

export default PositionAreaItem;
